<template>
  <div>
    <div class="pa-6">
      <v-container fluid>
        <v-row>
          <v-col class="yCenter">
            <h2 class="primary--text pr-5">{{ pageTitle }}</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <NoneChevronExpansionPanel>
              <template #header>
                <div class="headerAreaStyle d-flex align-center px-9">
                  <div class="titleStyle">
                    {{ $t('common.common_csv-upload-info') }}
                  </div>
                  <a
                    class="linkText--text csvSampleStyle font-weight-bold"
                    :href="csvSampleUrl"
                    target="_blank"
                  >
                    {{ '※' + $t('common.common_csv-sample') }}
                  </a>
                </div>
              </template>
              <template #content>
                <div class="mx-5 mb-5 mt-2">
                  <div class="pa-2">
                    <v-row no-gutters>
                      <v-col cols="8">
                        <InputFormNew
                          v-model="inputData"
                          :detail="items"
                          :titleCols="inputFormStyle.titleCols"
                          :contentsCols="inputFormStyle.contentsCols"
                        >
                          <template #uploadFile="{ item }">
                            <label class="input-item__label">
                              {{ $t('common.common_csv-file-select') }}
                              <input
                                type="file"
                                @change="fileSelected"
                                width="126px"
                              />
                            </label>
                            <span v-if="item.uploadFile" class="pl-3">{{
                              item.uploadFile.name
                            }}</span>
                          </template>
                          <template #country>
                            <div class="platformStyle">
                              <SelectPlatform v-model="selectedCountry" />
                            </div>
                          </template>
                          <template #platform="{ item }">
                            <div class="d-flex">
                              <SelectPlatformECName
                                v-model="item.platform"
                                :filterCountry="selectedCountry"
                                ref="platformEc"
                              />
                              <NormalTextButton
                                :text="`＋ ${
                                  $t('jd.jd_jdcom-store-name') +
                                  $t('common.common_register')
                                }`"
                                class="textButtonStyle"
                                @click.native="dialogInfo.register = true"
                              />
                            </div>
                          </template>
                        </InputFormNew>
                      </v-col>
                    </v-row>
                    <NormalButton
                      :text="$t('common.common_upload')"
                      height="50px"
                      width="130px"
                      textSize="16px"
                      class="text-right"
                      :disabled="
                        !(inputData.uploadFile && inputData.platform.value)
                      "
                      @click="clickDataOutputButton"
                    />
                  </div>
                </div>
              </template>
            </NoneChevronExpansionPanel>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <NoneChevronExpansionPanel>
              <template #header>
                <div class="resultHeaderAreaStyle d-flex align-center px-9">
                  <div class="resultTitleStyle">
                    {{ $t('common.common_register-result') }}
                  </div>
                </div>
              </template>
              <template #content>
                <div>
                  <div v-if="!UploadResult.success" class="mx-5 mb-5 mt-2">
                    <v-row no-gutters class="ma-7">
                      <v-col class="text-center">{{
                        $t('common.common_select-csv-and-register')
                      }}</v-col>
                    </v-row>
                  </div>
                  <div v-if="UploadResult.success">
                    <v-container class="uploadResultTextStyle ml-10 mb-5 mt-2">
                      <v-row class="my-2"
                        >{{ $t('common.common_total-price') }}：{{
                          UploadResult.total
                        }}</v-row
                      >
                      <v-row class="my-2"
                        >{{ $t('common.common_right-number') }}：{{
                          UploadResult.successDataCount
                        }}</v-row
                      >
                      <v-row class="my-2"
                        >{{ $t('common.common_error-number') }}：{{
                          UploadResult.errorDataCount
                        }}</v-row
                      >
                      <v-row
                        class="my-2 errorMessage"
                        v-if="UploadResult.errorDataCount > 0"
                      >
                        <div
                          v-for="errors in errorMessage"
                          :key="errors.prefix"
                        >
                          <div class="d-flex">
                            <span class="mx-4 mt-2">{{ errors.prefix }}</span>
                            <div class="d-flex flex-column">
                              <span
                                v-for="(error, index) of errors.values"
                                :key="index"
                                class="mt-2"
                              >
                                {{ error }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </v-row>
                      <v-row
                        ><NormalTextButton
                          :text="$t('common.common_check-csv-history')"
                          class="uploadResultTextButtonStyle"
                          @click.native="clickUploadCsvHistory()"
                      /></v-row>
                    </v-container>
                  </div>
                </div>
              </template>
            </NoneChevronExpansionPanel>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <ShopDialog
      v-model="dialogInfo.register"
      @success="shopRegisterSuccess()"
    />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import _cloneDeep from 'lodash/cloneDeep'
import { NoneChevronExpansionPanel } from '@/components/items'
import InputFormNew from '@/components/items/Designs/InputFormNew'
import { NormalButton, NormalTextButton } from '@/components/items'
import { ShopDialog } from '@/components/layouts/Dialogs'
import { i18n } from '@/main.js'
import {
  SelectPlatformECName,
  SelectPlatform
} from '@/components/items/Selectboxes'

export default {
  components: {
    NoneChevronExpansionPanel,
    InputFormNew,
    NormalButton,
    NormalTextButton,
    ShopDialog,
    SelectPlatformECName,
    SelectPlatform
  },
  data: () => {
    return {
      pageTitle: i18n.tc('common.common_csv-upload'),
      inputFormStyle: {
        titleCols: 3,
        contentsCols: 7,
        inputItemHeight: '32px'
      },
      inputData: {
        uploadFile: '',
        platform: {}
      },
      dialogInfo: {
        register: false
      },
      UploadResult: {
        success: false,
        total: 0,
        successDataCount: 0,
        errorDataCount: 0,
        errorList: []
      },
      items: [
        {
          name: 'uploadFile',
          text: i18n.tc('common.common_csv-file'),
          required: true
        },
        {
          name: 'country',
          text: i18n.tc('common.common_select-country-ec')
        },
        {
          name: 'platform',
          text: i18n.tc('jd.jd_jdcom-store-name'),
          required: true
        }
      ],
      selectedCountry: {}
    }
  },
  mounted() {
    this.init()
  },
  computed: {
    csvSampleUrl() {
      let url = ''
      switch (process.env.VUE_APP_ENV_NAME) {
        case 'production':
          url =
            'https://order-assets.spe-s.com/sample/master-upload/external_upload_sample.zip'
          break
        case 'staging':
          url =
            'https://stg-order-assets.spe-s.com/sample/master-upload/external_upload_sample.zip'
          break
        default:
          url =
            'https://dev-order-assets.spe-s.com/sample/master-upload/external_upload_sample.zip'
      }
      return url
    },
    errorMessage() {
      const errors = []
      const errorList = this.getCsvUploadErrorListFromState()

      /**
       * errors: [
       *   {
       *      prefix: '1行目',
       *      values: [
       *        'errorその1',
       *        'errorその2'
       *      ]
       *   }
       * ]
       */

      errorList.forEach((ele) => {
        for (const index in ele.errors) {
          ele.errors[index].flat().forEach((error) => {
            const prefix =
              i18n.locale === 'cn'
                ? `第${ele.lineNumber}行`
                : `${ele.lineNumber}行目`
            const errorObj = errors.find((error) => error.prefix === prefix)

            if (!errorObj) {
              errors.push({
                prefix,
                values: [error]
              })
            } else {
              errorObj.values.push(error)
            }
          })
        }
      })

      return errors
    }
  },
  methods: {
    ...mapActions('FileStore', ['externalSystemCsvUpload']),
    ...mapGetters('FileStore', [
      'getCsvUploadTotalFromState',
      'getCsvUploadErrorListFromState'
    ]),
    init() {
      this.$refs.platformEc.init()
    },
    async clickDataOutputButton() {
      const formatData = new FormData()
      formatData.append('uploadFile', this.inputData.uploadFile)
      formatData.append('platformId', this.inputData.platform.value)

      const success = await this.externalSystemCsvUpload(formatData)
      const total = this.getCsvUploadTotalFromState()
      const errorList = this.getCsvUploadErrorListFromState()
      // アップロード成功した場合
      if (success === 1) {
        this.UploadResult.total = total
        this.UploadResult.successDataCount = total
        this.UploadResult.errorDataCount = 0
        this.UploadResult.errorList = errorList
        this.UploadResult.success = true
      }
      // CSV内でバリデーションエラーがあった場合
      if (success === 2) {
        this.UploadResult.total = total
        this.UploadResult.successDataCount = total - errorList.length
        this.UploadResult.errorDataCount = errorList.length
        this.UploadResult.errorList = errorList
        this.UploadResult.success = true
      }
      // その他のエラーの場合
      if (success === 3) {
        this.UploadResult.success = false
      }
    },
    fileSelected(event) {
      this.inputData.uploadFile = event.target.files[0]
    },
    shopRegisterSuccess() {
      this.init()
      this.dialogInfo.register = false
    },
    clickUploadCsvHistory() {
      this.$router.push({
        name: 'csv.csvHistory'
      })
    }
  }
}
</script>
<style scoped lang="scss">
.titleStyle {
  font-size: 18px;
  font-weight: bold;
}
.resultTitleStyle {
  font-size: 15px;
  font-weight: bold;
}
.uploadResultTextStyle {
  font-size: 14px;
  font-weight: bold;
}
.headerAreaStyle {
  height: 70px;
}
.resultHeaderAreaStyle {
  height: 50px;
}
label > input {
  display: none;
}
label {
  padding: 5px 10px;
  border-radius: 4px;
  border: solid 1px #c8cfd7;
  background-color: #fff;
}
.selectboxStyle {
  max-width: 261px;
}
.textButtonStyle {
  margin: 0px 21px;
  ::v-deep .v-btn {
    font-size: 12px;
  }
}
.uploadResultTextButtonStyle {
  ::v-deep .v-btn {
    padding: 0;
    font-size: 14px;
  }
}
.platformStyle {
  width: 135px;
}
.csvSampleStyle {
  width: 88px;
  height: 12px;
  font-size: 12px;
  margin-left: 20px;
  margin-top: -6px;
  text-decoration: none;
}
.errorMessage {
  white-space: pre-wrap;
  display: flex;
  flex-direction: column;
}
</style>
